import { render } from "./ClientList.vue?vue&type=template&id=68043ffa&ts=true"
import script from "./ClientList.vue?vue&type=script&lang=ts"
export * from "./ClientList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__